import React, { useState } from "react";
import { AppBar, Toolbar, Button, Typography, Grid, Box, TextField, Drawer, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import image from '../Assests/background.jpg';
import Logo from '../Assests/btech colleges bangalore.png';

const Overlay = styled(Box)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "50%",
    height: "100%",
    backgroundColor: "#981c1c",
    clipPath: "polygon(0 0, 100% 0, 0 100%)",
    zIndex: 2, // Ensure the overlay is above both the background and navbar
});

const BannerSection = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        contact: "",
        course: "",
    });

    // State to control the mobile drawer
    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form submitted", formData);
    };

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                height: { md: "90vh", xs: "160vh" },
                display: "flex",
                flexDirection: "column",
                overflow: "hidden", // Prevents overflow of content outside the container
            }}
        >
            {/* Logo Centered Above Overlay */}
            <Box
                sx={{
                    position: "absolute",
                    top: { md: "10px", xs: "2px", sm: "10px" },
                    left: { md: "60%", xs: "45%", sm: "30%" },
                    transform: "translateX(-50%)",
                    zIndex: 4, // Ensure it stays above the overlay
                }}
            >
                <img
                    src={Logo}
                    alt="Logo"
                    style={{
                        height: `50px`, // Adjust size as needed
                        objectFit: "cover",
                    }}
                />
            </Box>

            {/* Background Image */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url(${image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    zIndex: -2, // Ensure the background image stays at the back
                }}
            />

            {/* Semi-Transparent Overlay */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(43, 42, 42, 0.4)", // Semi-transparent dark overlay
                    zIndex: -1, // Overlay above the background image
                }}
            />

            {/* Overlay Triangle */}
            <Overlay />

            {/* Navigation (Navbar) */}
            <AppBar position="static" sx={{ background: "white", top: { xs: "50px", sm: 0 }, zIndex: 1 }}>
                <Toolbar sx={{ justifyContent: "space-between" }}>
                    <Box
                        sx={{
                            display: { xs: "none", sm: "flex", md: "flex" },
                            gap: 2,
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            zIndex: 2,
                            width: "100%",
                            padding: "14px 0",
                            backgroundColor: "white",
                        }}
                    >
                        <Button sx={{ color: "black", fontWeight: "bold" }} component="a" href="#">
                            Home
                        </Button>
                        <Button sx={{ color: "black", fontWeight: "bold" }} component="a" href="https://www.getmycollege.com/about-us">
                            About
                        </Button>
                        <Button sx={{ color: "black", fontWeight: "bold" }} component="a" href="https://www.getmycollege.com/contact-us">
                            Contact
                        </Button>
                        <Button sx={{ color: "black", fontWeight: "bold" }} component="a" href="https://www.getmycollege.com/colleges?state=karnataka">
                            BtechColleges
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Hamburger Menu for Mobile */}
            <Box sx={{ display: { xs: "block", sm: "none" }, position: "absolute", top: 2, right: 0, zIndex: 4 }}>
                <IconButton onClick={handleDrawerToggle} sx={{ color: "black" }}>
                    <MenuIcon />
                </IconButton>
            </Box>

            {/* Mobile Drawer */}
            <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle}>
                <Box sx={{ width: 250, padding: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                        <img
                            src={Logo}
                            alt="Logo"
                            style={{
                                height: `40px`,
                                objectFit: "contain",
                            }}
                        />
                        <IconButton onClick={handleDrawerToggle} sx={{ color: "black" }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Button sx={{ textAlign: "left", fontWeight: "bold" }} component="a" href="#">
                        Home
                    </Button>
                    <Button sx={{ textAlign: "left", fontWeight: "bold" }} component="a" href="https://www.getmycollege.com/about-us">
                        About
                    </Button>
                    <Button sx={{ textAlign: "left", fontWeight: "bold" }} component="a" href="https://www.getmycollege.com/contact-us">
                        Contact
                    </Button>
                    <Button sx={{ textAlign: "left", fontWeight: "bold" }} component="a" href="https://www.getmycollege.com/colleges?state=karnataka">
                        BtechColleges
                    </Button>
                </Box>
            </Drawer>

            {/* Banner Content with Form and Text */}
            <Grid
                container
                spacing={2}
                sx={{
                    height: { md: "100%", xs: "60%", sm: "60%" },
                    alignItems: "center",
                    justifyContent: "flex-start",
                    padding: 4,
                    position: "relative",
                    zIndex: 2,
                }}
            >
                <Grid item xs={12} sm={4}>
                    <Box
                        sx={{
                            background: "rgba(255, 255, 255, 0.8)",
                            p: 2,
                            borderRadius: "15px",
                            boxShadow: 5,
                            marginTop: { xs: '-20px', md: '-100px' },
                        }}
                    >
                        <Typography variant="h4" sx={{ fontWeight: "bold", color: "#D32F2F", mb: 2, textAlign: 'center' }}>
                            Get In Touch
                        </Typography>
                        <form onSubmit={handleSubmit}>
                            <TextField label="Name" variant="outlined" fullWidth margin="normal" name="name" value={formData.name} onChange={handleChange} />
                            <TextField label="Email" variant="outlined" fullWidth margin="normal" name="email" value={formData.email} onChange={handleChange} />
                            <TextField label="Contact" variant="outlined" fullWidth margin="normal" name="contact" value={formData.contact} onChange={handleChange} />
                            <TextField label="Course" variant="outlined" fullWidth margin="normal" name="course" value={formData.course} onChange={handleChange} />
                        </form>
                        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: "#D32F2F", "&:hover": { backgroundColor: "#B71C1C" }, padding: "10px 20px" }}
                            >
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={8}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: "bold",
                            color: "white",
                            textAlign: "justify",
                            lineHeight: 1.5,
                            padding: "0 20px",
                            maxWidth: "100%",
                            marginTop: { xs: 2, sm: 0 },
                        }}
                    >
                        Discover the best BTech colleges in Bangalore at BTech Colleges Bangalore! Your ultimate guide to top engineering institutions, courses, admissions, and career opportunities. Explore comprehensive details to make informed decisions about your future in the Silicon Valley of India. Start your journey to excellence today with BTech Colleges Bangalore!
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 3,
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#D32F2F",
                                "&:hover": { backgroundColor: "#B71C1C" },
                                padding: "10px 20px",
                            }}
                            component="a"
                            href="#learn-more"
                        >
                            Learn More
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BannerSection;
